import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AccountSetupRoutingModule } from './account-setup-routing.module';
import { AccountSecurityStepComponent } from './components/account-security-step/account-security-step.component';
import { AccountSetupComponent } from './components/account-setup/account-setup.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ImportantInformationStepComponent } from './components/important-information-step/important-information-step.component';
import { OptOutComponent } from './components/opt-out/opt-out.component';
import { ServiceTermsComponent } from './components/service-terms/service-terms.component';
import { StepNameComponent } from './components/step-name/step-name.component';
import { StepComponent } from './components/step/step.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { SwitcherComponent } from './components/switcher/switcher.component';
import { UserProfileUsageComponent } from './components/user-profile-usage/user-profile-usage.component';
import { YourProfileStepComponent } from './components/your-profile-step/your-profile-step.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { SecurityQuestionComponent } from './components/security-question/security-question.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}
@NgModule({
  declarations: [
    AccountSetupComponent,
    StepperComponent,
    ImportantInformationStepComponent,
    YourProfileStepComponent,
    AccountSecurityStepComponent,
    FooterComponent,
    HeaderComponent,
    ErrorPageComponent,
    StepNameComponent,
    SwitcherComponent,
    StepComponent,
    UserProfileUsageComponent,
    OptOutComponent,
    ServiceTermsComponent,
    SetPasswordComponent,
    SecurityQuestionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AccountSetupRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ]
})
export class AccountSetupModule {}
